import React from 'react';

const SvgWireBit: React.FC<React.SVGProps<SVGSVGElement>> = (
  props: React.SVGProps<SVGSVGElement>,
) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 402.886 168.39"
      {...props}
    >
      <defs>
        <clipPath id="wireBit_svg__c">
          <path
            data-name="Rectangle 1301"
            fill="none"
            d="M0 0h186.832v16.079H0z"
          />
        </clipPath>
        <clipPath id="wireBit_svg__d">
          <path
            data-name="Rectangle 1311"
            fill="none"
            d="M0 0h48.114v63.312H0z"
          />
        </clipPath>
        <clipPath id="wireBit_svg__e">
          <path
            data-name="Rectangle 1314"
            fill="none"
            d="M0 0h48.114v64.317H0z"
          />
        </clipPath>
        <clipPath id="wireBit_svg__f">
          <path
            data-name="Rectangle 1317"
            fill="none"
            d="M0 0h23.228v18.089H0z"
          />
        </clipPath>
        <clipPath id="wireBit_svg__g">
          <path
            data-name="Rectangle 1321"
            fill="none"
            d="M0 0h25.248v18.089H0z"
          />
        </clipPath>
        <clipPath id="wireBit_svg__j">
          <path
            data-name="Rectangle 1333"
            fill="none"
            d="M0 0h23.228v17.084H0z"
          />
        </clipPath>
        <clipPath id="wireBit_svg__k">
          <path
            data-name="Rectangle 1338"
            fill="none"
            d="M0 0h49.485v61.302H0z"
          />
        </clipPath>
        <clipPath id="wireBit_svg__l">
          <path
            data-name="Rectangle 1344"
            fill="none"
            d="M0 0h39.386v68.337H0z"
          />
        </clipPath>
        <clipPath id="wireBit_svg__m">
          <path
            data-name="Rectangle 1354"
            fill="none"
            d="M0 0h64.634v63.312H0z"
          />
        </clipPath>
        <clipPath id="wireBit_svg__n">
          <path
            data-name="Rectangle 1357"
            fill="none"
            d="M0 0h64.634v64.317H0z"
          />
        </clipPath>
        <clipPath id="wireBit_svg__o">
          <path
            data-name="Rectangle 1360"
            fill="none"
            d="M0 0h22.218v18.089H0z"
          />
        </clipPath>
        <clipPath id="wireBit_svg__r">
          <path
            data-name="Rectangle 1376"
            fill="none"
            d="M0 0h22.218v17.084H0z"
          />
        </clipPath>
        <clipPath id="wireBit_svg__s">
          <path
            data-name="Rectangle 1381"
            fill="none"
            d="M0 0h50.495v61.302H0z"
          />
        </clipPath>
        <clipPath id="wireBit_svg__t">
          <path
            data-name="Rectangle 1387"
            fill="none"
            d="M0 0h40.396v68.337H0z"
          />
        </clipPath>
        <linearGradient
          id="wireBit_svg__a"
          x1={-31.035}
          y1={20.272}
          x2={-30.952}
          y2={20.272}
          gradientUnits="objectBoundingBox"
        >
          <stop offset={0} stopColor="#c1a98b" />
          <stop offset={1} stopColor="#ecb44c" />
        </linearGradient>
        <linearGradient
          id="wireBit_svg__i"
          x1={-31.035}
          y1={22.594}
          x2={-30.952}
          y2={22.594}
          href="#wireBit_svg__a"
        />
        <linearGradient
          id="wireBit_svg__p"
          x1={-10.459}
          y1={20.272}
          x2={-10.376}
          y2={20.272}
          href="#wireBit_svg__a"
        />
        <linearGradient
          id="wireBit_svg__q"
          x1={-10.459}
          y1={22.594}
          x2={-10.376}
          y2={22.594}
          href="#wireBit_svg__a"
        />
        <radialGradient
          id="wireBit_svg__b"
          cx={-228.522}
          cy={0.5}
          r={1.523}
          gradientTransform="matrix(0 -1 -109.542 0 -4622.197 -6736.98)"
          gradientUnits="objectBoundingBox"
        >
          <stop offset={0} stopColor="#f6f6f6" />
          <stop offset={0.496} stopColor="#f6f6f6" />
          <stop offset={1} stopColor="#f5f5f5" />
        </radialGradient>
        <radialGradient
          id="wireBit_svg__u"
          cx={233.734}
          r={1.523}
          gradientTransform="matrix(0 -1 111.554 0 -4713 -2520.05)"
          href="#wireBit_svg__b"
        />
        <image
          id="wireBit_svg__h"
          width={25.124}
          height={18.089}
          href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAASCAYAAACuLnWgAAAAAXNSR0IArs4c6QAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAAGaADAAQAAAABAAAAEgAAAAAM64R1AAABsUlEQVQ4Ea2UWU/DMBCEEwj3IVF4QAiJ///HEC/cUK62Yb6VJ3KNUxXESqP1sbvjWTtp+75vatbKauur1lSrWqwt11NxE+A9XllfmyaAy+PIGUiyk29opwTBNTIXW2i/RGOyjuzMKM7aVgbmrGM5UU4w095XBuaQhgVJUmGCHe3sCwcJzE1UklCIgh/Ca8JUHpup7gI1QaIFkiFBAQQT4TT5I3mINgXiACrAXIDgWbgTbgXMrYu4rrgLSFAAwaVwIUAIMXtum4ZRiBZxcgiuBQxSwN6c+mNKThRwLlwlfyi/LaDGhopP4UW4ETg9LXsQUMaBQrVJNF9q2Z7mxwIqztKYlg2JGlOUE+8KkNEq8qwYgrBcvtf+3edKuCRORy/fhCeBXtOm9+TH2kUc8eSRTx3qhZkkJ+Ai7wX6jFL6u87FE08e+UtEHe84vTCr4PL8FEn47RMm3yTx1Y8pUVxc6qP8Xz5Gk0TLyn8X7YGYF2Iw9wMZXozW3HM6UP2t0CXtRUG8zQluHcVrBI7PicjJ4ZhmUOKVdD8+Md5jh9Q8ZCZEgMcR+4PEFRKZp2v5sriTvgFtH8YzzqtN5gAAAABJRU5ErkJggg=="
        />
      </defs>
      <g data-name="Group 13301" className="wire-body">
        <g data-name="Group 10204">
          <g data-name="Group 10203" opacity={0.15}>
            <g
              data-name="Group 10202"
              clipPath="url(#wireBit_svg__c)"
              transform="translate(108.753 76.937)"
            >
              <g data-name="Group 10201">
                <g data-name="Group 10200" clipPath="url(#wireBit_svg__c)">
                  <image
                    data-name="Rectangle 1299"
                    width={185.916}
                    height={16.079}
                    href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAALkAAAAQCAYAAABKvt56AAAAAXNSR0IArs4c6QAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAAuaADAAQAAAABAAAAEAAAAADiBC4HAAABeElEQVRoBe2asUoDQRRFs6JioSDa2+sPpPbL/QeLpLdXBBXEhGzOGXdAY7WVPLgPTmbDhjB7c3jMZnYYx3FhDVQ74HAaMySBqgk0qXG7jYMjfh9xNcdwNo2+TyWBignsmPQWPh3xe2fXlhO4hhu4glNIRyeEVKkE7Nxf8AJP8Awbu7dlB1fwe7iDc4jkhJAqlYCSv8MKHuADmuTKrOx28ltYwiVkyUIIqVIJuFR5BWV/BL0eeidXaJcsF6DgLlkiOSGkSiWg5JYe63NzuEvuCTu6eKLDYSoJlEpAd7vLbeLN9FKXkMkmgZkJRPKZgeXj9RKI5PV+s8x4ZgI/1+TekYqL976An/l1+XgS+NcEurvd5TaZLrknN/AG/gVjpct/55DXOgnosf7qsT63Zq3kWu82qLtDa/DONJtBhJAql4Auuxmkx/qs12P/qyXb+qSRKp+Akv/Z1s8DWuV/11zAQQIuUX4/oDU9jZhHbQ+SytvSCdjRF7jdxj3/RFgEGJ7x6gAAAABJRU5ErkJggg=="
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
        <path
          data-name="Path 21568"
          d="M291.522 79.689H111.58v8.794h179.942z"
          fill="#e5e5e5"
        />
        <path
          data-name="Path 21569"
          d="M396.827 168.391h-107.84a6.044 6.044 0 01-6.059-6.03V6.03A6.045 6.045 0 01288.987 0h107.84a6.045 6.045 0 016.059 6.03v156.327a6.044 6.044 0 01-6.059 6.03"
          fill="#f4f4f4"
        />
        <path
          data-name="Path 21570"
          d="M396.827 168.391h-49.441V0h49.441a6.045 6.045 0 016.059 6.03v156.327a6.044 6.044 0 01-6.059 6.03"
          fill="#ffba08"
        />
        <g data-name="Group 10221">
          <g data-name="Group 10220" opacity={0.1}>
            <g
              data-name="Group 10219"
              clipPath="url(#wireBit_svg__d)"
              transform="translate(350.12 87.991)"
            >
              <g data-name="Group 10218">
                <g data-name="Group 10217" clipPath="url(#wireBit_svg__d)">
                  <image
                    data-name="Rectangle 1309"
                    width={47.878}
                    height={47.13}
                    href="data:image/png;base64,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"
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
        <path
          data-name="Path 21571"
          d="M375.136 96.159a16.343 16.343 0 1016.423 16.342 16.383 16.383 0 00-16.423-16.342m2.72 27.237a11.229 11.229 0 118.229-13.6 11.286 11.286 0 01-8.229 13.6"
          fill="#ffc950"
        />
        <g data-name="Group 10226">
          <g data-name="Group 10225" opacity={0.1}>
            <g
              data-name="Group 10224"
              clipPath="url(#wireBit_svg__e)"
              transform="translate(350.12 30.709)"
            >
              <g data-name="Group 10223">
                <g data-name="Group 10222" clipPath="url(#wireBit_svg__e)">
                  <image
                    data-name="Rectangle 1312"
                    width={47.878}
                    height={47.878}
                    href="data:image/png;base64,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"
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
        <path
          data-name="Path 21572"
          d="M375.136 39.569a16.343 16.343 0 1016.423 16.343 16.383 16.383 0 00-16.423-16.343m2.72 27.237a11.229 11.229 0 118.229-13.6 11.285 11.285 0 01-8.229 13.6"
          fill="#ffc950"
        />
        <g data-name="Group 10231">
          <g data-name="Group 10230" opacity={0.1}>
            <g
              data-name="Group 10229"
              clipPath="url(#wireBit_svg__f)"
              transform="translate(314.773 99.045)"
            >
              <g data-name="Group 10228">
                <g data-name="Group 10227" clipPath="url(#wireBit_svg__f)">
                  <image
                    data-name="Rectangle 1315"
                    width={23.114}
                    height={18.089}
                    href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABcAAAASCAYAAACw50UTAAAAAXNSR0IArs4c6QAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAAF6ADAAQAAAABAAAAEgAAAABNz3zjAAABqElEQVQ4EbWUWU8DMQyEd2G5D4njASEk/v8fQ7xw39B2mc94qjSECh6wNE3sOGNnkm0/jmPXsl7Wirdi4miS9HU8SU3M6HmTV0ETU8PzyJ2TF52uaKUGyWURk8wUr9G5yMCuwiAltlYAnzhGgZJ4Iv+jAD7FwoI8uzbxhla2hZ0EfllAbhBA9CY8JZ41YhPxzeg+yBWgI8jpGOJD4SjHPY0UWBXc+VRziB+Ea+FKwCwRpxuHSmvI6RjiM+FUoBAFWTM5UtApxBcCRjHA2hTenzo/UMKJcJ7jrsZ1gdPR3bvwKFymjzS3AichJ5owufwFabbk7wt0fZxzpHHndLgpUARJyOdkJtb0y4nJf/yUnXMJHBnNXoR7AU2R4zXHWhbWySOffez3U40nJj8CJuaibgT0hAwdl10oeeSzb6HAwHvMF2NyLsdPiw2/fYrsM3l8pZallARCjEu7E/7yEZk8pKn/W5CBgty8gU8c82thzkmbnz9qkODOmWPeYIkgLYkjST++NPJqOKebd+5I6k+HGKPnEah+KOJCNOx5pH0j9+YsYnfpWJM6+ROgC8EzQHkngwAAAABJRU5ErkJggg=="
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
        <path
          data-name="Rectangle 1318"
          fill="#fff"
          d="M319.786 103.54h9.29v4.952h-9.29z"
        />
        <g data-name="Group 10236">
          <g data-name="Group 10235" opacity={0.1}>
            <g
              data-name="Group 10234"
              clipPath="url(#wireBit_svg__g)"
              transform="translate(314.773 82.966)"
            >
              <g data-name="Group 10233">
                <g data-name="Group 10232" clipPath="url(#wireBit_svg__g)">
                  <use data-name="Rectangle 1319" href="#wireBit_svg__h" />
                </g>
              </g>
            </g>
          </g>
        </g>
        <path
          data-name="Rectangle 1323"
          transform="translate(319.785 87.085)"
          fill="url(#wireBit_svg__a)"
          d="M0 0h12.091v4.952H0z"
        />
        <path
          data-name="Rectangle 1324"
          fill="none"
          d="M319.785 87.085h12.091v4.952h-12.091z"
        />
        <g data-name="Group 10245">
          <g data-name="Group 10244" opacity={0.1}>
            <g
              data-name="Group 10243"
              clipPath="url(#wireBit_svg__g)"
              transform="translate(314.773 70.907)"
            >
              <g data-name="Group 10242">
                <g data-name="Group 10241" clipPath="url(#wireBit_svg__g)">
                  <use data-name="Rectangle 1325" href="#wireBit_svg__h" />
                </g>
              </g>
            </g>
          </g>
        </g>
        <path
          data-name="Rectangle 1329"
          transform="translate(319.785 75.585)"
          fill="url(#wireBit_svg__i)"
          d="M0 0h12.091v4.952H0z"
        />
        <path
          data-name="Rectangle 1330"
          fill="none"
          d="M319.785 75.585h12.091v4.952h-12.091z"
        />
        <g data-name="Group 10254">
          <g data-name="Group 10253" opacity={0.1}>
            <g
              data-name="Group 10252"
              clipPath="url(#wireBit_svg__j)"
              transform="translate(314.773 55.833)"
            >
              <g data-name="Group 10251">
                <g data-name="Group 10250" clipPath="url(#wireBit_svg__j)">
                  <image
                    data-name="Rectangle 1331"
                    width={23.114}
                    height={17.084}
                    href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABcAAAARCAYAAAA2cze9AAAAAXNSR0IArs4c6QAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAAF6ADAAQAAAABAAAAEQAAAAAKbwYzAAABpElEQVQ4EZWTbUsDQQyE7/R8R0QFP+j//2t+EFTEd217zpNmSliXioHpZrPZySS3Hed5Hno2ynrxXkwcXZKxjSepiVntd3kVNDE17Efuhrwo3dFJC5JrEZOsFG8xuMjErWKQEtsrYE8co0AlXmj/XcCeYmFBnqpNfKCTY+Ekwb4W0DYIIPoUXhNvWrGF+FaoD3IFUAQ5iiG+EC6Fc+FUoMCuYOVL+RA/C4/CvYB5RHQ3T82sIUcx5NcJ/COBM5MzinfhQbgVIKMY4GwJb6uc/aFwJlwJN7miHnK6Qx0EqKYo43kR6MDjCxEmVzyMIO1DRBG6gBjsCyb/ko8xb/LI99jkrq0lpz3mibIPgcsoxHrKOScvRqHVL0nuug1WgrRLiyQ/CXcCxZnttpmTRz73/BSjyMSTyY/qWaKGD8WIIObyX6+FfO7RATzxR/JYrJxDv1e+PIr+885NHsrbv7//SMzXQABxzE8R32OE0IixMA0SrBwf8wWPCNJKHEn6icuZT26Fc4aNckdy/ijEWO1HoPmhiAsh2H6k/SL35Szi7da1JXXyD2uEvktrogu/AAAAAElFTkSuQmCC"
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
        <path
          data-name="Rectangle 1334"
          fill="#fff"
          d="M319.731 59.901h9.29v4.952h-9.29z"
        />
        <path
          data-name="Rectangle 1335"
          fill="#e8e8e8"
          d="M312.659 69.531h7.126v28.505h-7.126z"
        />
        <g data-name="Group 10259">
          <g data-name="Group 10258" opacity={0.1}>
            <g
              data-name="Group 10257"
              clipPath="url(#wireBit_svg__k)"
              transform="translate(281.446 58.847)"
            >
              <g data-name="Group 10256">
                <g data-name="Group 10255" clipPath="url(#wireBit_svg__k)">
                  <image
                    data-name="Rectangle 1336"
                    width={49.243}
                    height={61.302}
                    href="data:image/png;base64,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"
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
        <path
          data-name="Path 21573"
          d="M287.158 59.953v5.723h-4.23v37.117h4.23l.02 5.7h32.607V75.585h-25.438v-6.054h25.438v-9.578zm32.571 38.081h-25.493v-6.053h25.494z"
          fill="#fff"
        />
        <g data-name="Group 10268">
          <g data-name="Group 10267" opacity={0.1}>
            <g
              data-name="Group 10266"
              clipPath="url(#wireBit_svg__l)"
              transform="translate(267.308 44.778)"
            >
              <g data-name="Group 10265">
                <g data-name="Group 10264" clipPath="url(#wireBit_svg__l)">
                  <image
                    data-name="Rectangle 1342"
                    width={39.193}
                    height={68.337}
                    href="data:image/png;base64,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"
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
        <path
          data-name="Rectangle 1345"
          fill="#fff"
          d="M282.928 65.678h8.378v37.118h-8.378z"
        />
        <path
          data-name="Path 21574"
          d="M6.059 168.391h107.835a6.044 6.044 0 006.059-6.03V6.03A6.045 6.045 0 00113.894 0H6.059A6.045 6.045 0 000 6.03v156.327a6.044 6.044 0 006.059 6.03"
          fill="#f4f4f4"
        />
        <path
          data-name="Path 21575"
          d="M6.059 168.391H55.5V0H6.059A6.045 6.045 0 000 6.03v156.327a6.044 6.044 0 006.059 6.03"
          fill="#ffba08"
        />
        <g data-name="Group 10283">
          <g data-name="Group 10282" opacity={0.1}>
            <g
              data-name="Group 10281"
              clipPath="url(#wireBit_svg__m)"
              transform="translate(2.714 87.991)"
            >
              <g data-name="Group 10280">
                <g data-name="Group 10279" clipPath="url(#wireBit_svg__m)">
                  <image
                    data-name="Rectangle 1352"
                    width={64.317}
                    height={63.312}
                    href="data:image/png;base64,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"
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
        <path
          data-name="Path 21576"
          d="M11.327 112.501A16.423 16.423 0 1027.75 96.159a16.383 16.383 0 00-16.423 16.342m5.475-2.706a11.278 11.278 0 118.229 13.6 11.284 11.284 0 01-8.229-13.6"
          fill="#ffc950"
        />
        <g data-name="Group 10288">
          <g data-name="Group 10287" opacity={0.1}>
            <g
              data-name="Group 10286"
              clipPath="url(#wireBit_svg__n)"
              transform="translate(2.714 30.709)"
            >
              <g data-name="Group 10285">
                <g data-name="Group 10284" clipPath="url(#wireBit_svg__n)">
                  <image
                    data-name="Rectangle 1355"
                    width={64.317}
                    height={64.317}
                    href="data:image/png;base64,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"
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
        <path
          data-name="Path 21577"
          d="M11.327 55.912A16.423 16.423 0 1027.75 39.569a16.383 16.383 0 00-16.423 16.343m5.478-2.707a11.278 11.278 0 118.229 13.6 11.286 11.286 0 01-8.229-13.6"
          fill="#ffc950"
        />
        <g data-name="Group 10293">
          <g data-name="Group 10292" opacity={0.1}>
            <g
              data-name="Group 10291"
              clipPath="url(#wireBit_svg__o)"
              transform="translate(69.367 99.045)"
            >
              <g data-name="Group 10290">
                <g data-name="Group 10289" clipPath="url(#wireBit_svg__o)">
                  <image
                    data-name="Rectangle 1358"
                    width={22.109}
                    height={18.089}
                    href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAASCAYAAABfJS4tAAAAAXNSR0IArs4c6QAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAAFqADAAQAAAABAAAAEgAAAADKabegAAABlUlEQVQ4Ea2UWU/EMAyEWyj3IXE8IITE//9jiBfO5WZ3y3zBE2XTgiqEpVknjjN2Jum2fd83Y9bKxuJ1TPtHCdo6HoQmxXs84FTApPB7nPIycdHhmlZqkOwCJlgqVqNxgY4dhUFIbKMAc+KlQTgXPgswJ54sEUe3Jt3Syq6wF2Bekpv0XfHnwIs8NhfXkq4TsQIcE2I6hfRYOAl/IA/5uoAtBEhnwq1wI2CWBan6rtIWYjqF9EI4FyhCMTfBkekQ0isBoxBAmgWcTq47PlLCmXAZfl9+U8A+hCfhWqBL5LgXOAGnhitLofGKHDuaHwp0exrjknhbMQogA7mc1KQaDm87Bf/jx1LAhegcDZ1ehUcBHen0LbxcloI1cshlD3v9xvOFlKRczJ2AhhwP7X66PHLIZc8Kecebi5fhbrkMPyE2THlu7DFx+vosRd2x8tLzeZCf+oGYOMlR/1dwdIr9+ZNGAe3PGjPGkMPfPB1QCGCT/oS+U5UcBTxvQm+T4D3OOTGgs9Qd3p06aUCcF1TB4998TejcL2p8uDP/W9RGAAAAAElFTkSuQmCC"
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
        <path
          data-name="Rectangle 1361"
          fill="#fff"
          d="M73.81 103.54h9.29v4.952h-9.29z"
        />
        <g data-name="Group 10298">
          <g data-name="Group 10297" opacity={0.1}>
            <g
              data-name="Group 10296"
              clipPath="url(#wireBit_svg__g)"
              transform="translate(66.338 82.966)"
            >
              <g data-name="Group 10295">
                <g data-name="Group 10294" clipPath="url(#wireBit_svg__g)">
                  <use data-name="Rectangle 1362" href="#wireBit_svg__h" />
                </g>
              </g>
            </g>
          </g>
        </g>
        <path
          data-name="Rectangle 1366"
          transform="translate(71.01 87.085)"
          fill="url(#wireBit_svg__p)"
          d="M0 0h12.091v4.952H0z"
        />
        <path
          data-name="Rectangle 1367"
          fill="none"
          d="M71.01 87.085h12.091v4.952H71.01z"
        />
        <g data-name="Group 10307">
          <g data-name="Group 10306" opacity={0.1}>
            <g
              data-name="Group 10305"
              clipPath="url(#wireBit_svg__g)"
              transform="translate(66.338 70.907)"
            >
              <g data-name="Group 10304">
                <g data-name="Group 10303" clipPath="url(#wireBit_svg__g)">
                  <use data-name="Rectangle 1368" href="#wireBit_svg__h" />
                </g>
              </g>
            </g>
          </g>
        </g>
        <path
          data-name="Rectangle 1372"
          transform="translate(71.01 75.585)"
          fill="url(#wireBit_svg__q)"
          d="M0 0h12.091v4.952H0z"
        />
        <path
          data-name="Rectangle 1373"
          fill="none"
          d="M71.01 75.585h12.091v4.952H71.01z"
        />
        <g data-name="Group 10316">
          <g data-name="Group 10315" opacity={0.1}>
            <g
              data-name="Group 10314"
              clipPath="url(#wireBit_svg__r)"
              transform="translate(69.367 55.833)"
            >
              <g data-name="Group 10313">
                <g data-name="Group 10312" clipPath="url(#wireBit_svg__r)">
                  <image
                    data-name="Rectangle 1374"
                    width={22.109}
                    height={17.084}
                    href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAARCAYAAADZsVyDAAAAAXNSR0IArs4c6QAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAAFqADAAQAAAABAAAAEQAAAACNyc1wAAABlUlEQVQ4EY2T20oEQQxEd3TEGyIq+KD//2s+CCridXF3xzox1TbZWTFQ0+l0UkknPcM0TYs5GSRz9mpT/CzBUO1JaFJW61ucMpgUfuvh14i7Cvd0UoGzE5hgI1vFwglGIjqBENtBB/bYe4FwJXx1YI89JIizWpMe6uREOE2w78lNupT9LfGuFVmJa0PVQSwD14SYSiG9FK6EC+FMgHxfQNYCpC/Ck/AgIG4LrZrG0luIqRTimwT6scAZwvU/hEfhToCIRICzNZy1YvZHwrlwLdzmStU9MdWSjL6+ClTudnH71grpIRi5MiQkoHpIK7FM0V988CXGr0bqT5ZQ8sO16CFX+hQYDtUhtWLO8Inra/UzlPpLjNHTxvlZuM9z+rmrx/jgS4yfWyQYeRo5QIjJTiUMhqtBSvBfrwJfYoiFI34SD88Vc+g3yZSp5r/v2MRRcf2l/ZPQT8PTlqmJ2waZEa2gA3i5Ykc4wG0hEUA89QjUHp8K/EJaxc2ghks3Sa/bxSsJnIRCrcf5FrGjcqDe7lwroR2/AaA6tUuR92ImAAAAAElFTkSuQmCC"
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
        <path
          data-name="Rectangle 1377"
          fill="#fff"
          d="M73.865 59.901h9.29v4.952h-9.29z"
        />
        <path
          data-name="Rectangle 1378"
          fill="#e8e8e8"
          d="M83.101 69.531h7.126v28.505h-7.126z"
        />
        <g data-name="Group 10321">
          <g data-name="Group 10320" opacity={0.1}>
            <g
              data-name="Group 10319"
              clipPath="url(#wireBit_svg__s)"
              transform="translate(81.486 58.847)"
            >
              <g data-name="Group 10318">
                <g data-name="Group 10317" clipPath="url(#wireBit_svg__s)">
                  <image
                    data-name="Rectangle 1379"
                    width={50.248}
                    height={61.302}
                    href="data:image/png;base64,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"
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
        <path
          data-name="Path 21578"
          d="M83.101 59.953v9.575h25.438v6.054H83.101v32.907h32.608l.02-5.7h4.23v-37.11h-4.23v-5.726zm25.549 38.081H83.156v-6.053h25.493z"
          fill="#fff"
        />
        <g data-name="Group 10330">
          <g data-name="Group 10329" opacity={0.1}>
            <g
              data-name="Group 10328"
              clipPath="url(#wireBit_svg__t)"
              transform="translate(95.625 44.778)"
            >
              <g data-name="Group 10327">
                <g data-name="Group 10326" clipPath="url(#wireBit_svg__t)">
                  <image
                    data-name="Rectangle 1385"
                    width={40.198}
                    height={68.337}
                    href="data:image/png;base64,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"
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
        <path
          data-name="Rectangle 1388"
          fill="#fff"
          d="M111.58 65.678h8.378v37.118h-8.378z"
        />
        <path
          data-name="Rectangle 1340"
          transform="translate(319.785 69.531)"
          fill="url(#wireBit_svg__b)"
          d="M0 0h.056v6.054H0z"
        />
        <path
          data-name="Rectangle 1341"
          fill="none"
          d="M319.785 69.531h.056v6.054h-.056z"
        />
        <path
          data-name="Rectangle 1383"
          transform="translate(83.045 69.531)"
          fill="url(#wireBit_svg__u)"
          d="M0 0h.055v6.054H0z"
        />
        <path
          data-name="Rectangle 1384"
          fill="none"
          d="M83.045 69.531h.055v6.054h-.055z"
        />
      </g>
    </svg>
  );
};

export default SvgWireBit;
